<app-block-container [blockId]="blockId" [enabledTitle]="false" [renderOptions]="renderOptions" [enabledMoreBtn]="false"
    [section]="section">
    <div class="iframe-container" [ngStyle]="renderOptions?.container">
        <iframe #iframe frameborder="0" class="inner-iframe-container"
            style="width: 100%;height:-webkit-fill-available;min-height: 94vh;" [src]="_url" *ngIf="_url"></iframe>
    </div>
</app-block-container>